/** Lo que manda `GET /resumen-macro` (`api/v1/resumen_macro.py`). */

export type Partida = {
  titulo: string
  detalle: string
  moneda: string
  monto: string
  usd: string | null
  clase: string
  expediente: string | null
  fecha: string | null
  suma: boolean
  nota: string | null
  origen: string
  ref_id: number | null
  estado: string | null
  orden: string | null
  conciliacion: string | null
  cierre_id: number | null
  corte: string | null
  diferencia: string | null
  /** Sólo en las CxP: OPERATIVA o ADMINISTRATIVA. Las fotos anteriores no lo traen. */
  rubro?: string | null
}

export type Bloque = {
  clave: string
  titulo: string
  total: string
  sin_convertir: string[]
  partidas: Partida[]
}

export type Resumen = {
  fecha: string
  semana_desde: string
  semana_hasta: string
  reserva_pct: string
  cobertura: {
    disponible: string
    reserva: string
    operativo: string
    compromisos: string
    ratio: string | null
    excedente: string
    semaforo: "VERDE" | "AMARILLO" | "ROJO"
    motivo: string
  }
  bancos: Bloque
  sin_identificar: Bloque
  transito: Bloque
  cxc: Bloque
  cxp: Bloque
  gastos_semana: Bloque
  proyeccion_cxp: string
  cxc_valija: string
  estados_pago: Record<string, string>
  clases_cxc: Record<string, string>
  estados_conciliacion: Record<string, string>
  conciliado: boolean
  sin_conciliar: string
  discrepancias: number
  incluye_nomina: boolean
  error_2: string | null
  /** (RM-7) Lo que el planificador propone pagar el viernes: `clase:ref_id`. */
  propuesta_pago: string[]
  /** A qué tasa se valoraron los bolívares (30/10). Las fotos anteriores no lo traen. */
  tasa_bs?: string
  tasas_bs?: { codigo: string; nombre: string; valor: string }[]
}

/** Lo operativo y lo administrativo no se totalizan juntos (`rubro_de`, 30/10). */
export const esOperativa = (p: Partida) =>
  p.rubro ? p.rubro === "OPERATIVA" : p.clase === "CXP_OPERATIVA"

/** Suma en céntimos lo que tiene tasa: los subtotales que la pantalla compone. */
export const sumaUsd = (ps: Partida[]) =>
  ps.reduce((t, p) => t + (p.usd !== null ? Math.round(Number(p.usd) * 100) : 0), 0) / 100
